import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=d21de1ac&lang=pug&"
var script = {}
import style0 from "./Heart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!D:\\nvm\\v10.16.3\\node_modules\\@vue\\cli-service-global\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports